<template>
  <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
  <Form v-else :exhibit="exhibit" @exhibit-action="updateExhibit" />
</template>

<script>
import axios from 'axios'
import Form from '@/pages/admin/exhibits/form'
import { deserialize } from 'deserialize-json-api'
import DataLoader from '@/components/commons/DataLoader'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    Form,
    DataLoader
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ギャラリー編集',
      fetchLoading: true,
      exhibit: {
        published: 1,
        priority: 0,
        exhibitableId: null,
        exhibitableType: null,
        imagableUrl: null,
        imageDirectUrl: null,
        exhibitRelatedPostsAttributes: [],
        imageSourceUrl: ''
      }
    }
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchExhibit()
    this.fetchLoading = false
  },
  methods: {
    setExhibitData (data) {
      const response = deserialize(data).data
      const REGEX = /^(https?|ftp)(:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+)$/
      if (response.file.match(REGEX)) {
        this.exhibit.imageDirectUrl = response.file
      } else {
        this.exhibit.imagableUrl = response.file
      }
      this.exhibit.published = response.published
      this.exhibit.priority = response.priority
      this.exhibit.exhibitableId = response.exhibitableId
      this.exhibit.exhibitableType = response.exhibitableType
      if (typeof response.exhibitRelatedPosts !== 'undefined') {
        response.exhibitRelatedPosts.map((item) => {
          this.exhibit.exhibitRelatedPostsAttributes.push({
            id: item.id,
            post: item.post,
            postId: item.postId,
            destroy: false
          })
        })
      }
      this.exhibit.imageSourceUrl = response.imageSourceUrl
    },
    fetchExhibit () {
      return axios
        .get(`/api/exhibits/${this.$route.params.id}`)
        .then(({ data }) => {
          this.setExhibitData(data)
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
    },
    updateExhibit () {
      this.exhibit.exhibitRelatedPostsAttributes.map((item) => {
        item._destroy = item.destroy
        delete item.destroy
      })
      axios
        .patch(`/api/exhibits/${this.$route.params.id}`, {
          exhibit: this.exhibit
        })
        .then(
          () => {
            const payload = {
              status: 200,
              message: '更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>
